import { PlayerFinderGoalsEnum } from 'types/generated/client';

/** The questionnaire steps. Goals is a gate-opener, so the numbered steps start after it. */
export enum OnboardingStep {
  Goals = 'GOALS',
  ProfileBasics = 'PROFILE_BASICS',
  PlayingLevel = 'PLAYING_LEVEL',
  PreferredCourts = 'PREFERRED_COURTS',
  Verification = 'VERIFICATION',
}

/** Numbered steps shown in the "Step N of 4" progress bar. */
export const TOTAL_NUMBERED_STEPS = 4;

interface GoalOption {
  value: PlayerFinderGoalsEnum;
  label: string;
  /**
   * Emoji-style glyph with baked-in colour, so it's an image asset. These are the
   * same Socials / Open Play / Tournament glyphs the explore bar uses — see
   * `getExploreTypes` in screens/PlayerHomeV2/utils.
   */
  iconSrc: string;
}

export const GOAL_OPTIONS: GoalOption[] = [
  {
    value: PlayerFinderGoalsEnum.MeetNewPeople,
    label: 'Meet new people',
    iconSrc: '/images/programming/socials.png',
  },
  {
    value: PlayerFinderGoalsEnum.CasualPlay,
    label: 'Recreational play',
    // The explore bar's /images/programming/open-play.png is this same glyph in
    // all-pink; the questionnaire design recolours the left figure green.
    iconSrc: '/images/players/finder/goal-casual-play.svg',
  },
  {
    value: PlayerFinderGoalsEnum.CompetitivePlay,
    label: 'Competitive play',
    iconSrc: '/images/player-home-v2/search-bar-icons/tournament-gradient.svg',
  },
];

// The form vocabulary is shared with the profile's in-place editors, so it lives
// in utils/shared/playerFinder — re-exported here for existing importers.
export {
  BIRTHDAY_VISIBILITY_OPTIONS,
  GENDER_OPTIONS,
  PLAYING_LEVEL_SPORTS,
  RatingSystem,
  SELF_RATE_SKILL_LEVELS,
  SOCIAL_LINK_OPTIONS,
  SocialLink,
} from 'utils/shared/playerFinder';
export type {
  PlayingLevelValues,
  PreferredCourtsValues,
  ProfileBasicsValues,
  ProfilePhotos,
  UploadedImage,
} from 'utils/shared/playerFinder';

// Shared with the home Filters sheet — kept here as re-exports for existing importers.
export {
  AVAILABILITY_DAY_OPTIONS,
  AvailabilityDayShorthand,
  TIME_OF_DAY_OPTIONS,
} from 'utils/shared/playerAvailability';
export type { AvailabilityDay } from 'utils/shared/playerAvailability';
